import { CREATE_VENDOR_MANAGEMENT_FAILURE, CREATE_VENDOR_MANAGEMENT_FORM, CREATE_VENDOR_MANAGEMENT_REQUEST, CREATE_VENDOR_MANAGEMENT_SUCCESS, SET_PROGRAM_NAME_VENDOR_MANAGEMENT, VENDOR_MANAGEMENT_FORM_RESET } from "./vendorManagement.actionType";

export const VENDOR_MANAGEMENT = 'vendorManagement';

let initialState = {

    vendorManagement: [],
    userform: {},
    programId : 1,
}

export let vendorManagementReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case CREATE_VENDOR_MANAGEMENT_REQUEST:

            return {
                ...state,
                loading: true,
            };
        case CREATE_VENDOR_MANAGEMENT_FORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
            };
        case CREATE_VENDOR_MANAGEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload,
            };
        case VENDOR_MANAGEMENT_FORM_RESET:
            return {
                ...state,
                userform: {}
            }
            case SET_PROGRAM_NAME_VENDOR_MANAGEMENT:
            return {
                ...state,
                programId: payload
            };
        case CREATE_VENDOR_MANAGEMENT_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}